'use client';

import { useMemo } from 'react';

import { RadioTile } from '@bytel/trilogy-react';

import { MobilePlanType, RenewDelayType } from '@app-types/plan';

import { PlanSubTypeId } from '@constants/plan';

interface PlanRadioTileProps {
    plan: MobilePlanType;
    currentPlan?: MobilePlanType | null;
    onPlanChange: (plan: MobilePlanType) => void;
    disabled?: boolean;
}

export function PlanRadioTile({ plan, currentPlan, onPlanChange, disabled = false }: Readonly<PlanRadioTileProps>) {
    const isSelected = useMemo(() => {
        return currentPlan?.gencode === plan.gencode;
    }, [currentPlan?.gencode, plan.gencode]);

    const description = useMemo(() => {
        const renewDelayMonths = plan.renewDelay === RenewDelayType.MONTHLY_12 ? '12' : '24';
        const smartChangeLabel =
            plan.subTypeId === PlanSubTypeId.SMART_CHANGE
                ? `Téléphone changeable dès ${renewDelayMonths} mois`
                : undefined;

        if (plan.shortDescription) {
            return smartChangeLabel ? `${plan.dataEnvelope} - ${smartChangeLabel}` : plan.dataEnvelope;
        }

        return smartChangeLabel;
    }, [plan]);

    return (
        <RadioTile
            id={plan.gencode}
            label={plan.shortDescription ?? plan.dataEnvelope}
            description={description}
            name='planChoice'
            onChange={() => onPlanChange(plan)}
            checked={isSelected}
            horizontal
            disabled={disabled}
        />
    );
}
